import React, { useMemo } from "react";
import { nanoid } from "nanoid";
export var CustomCompGroup = function(param) {
    var customComponents = param.customComponents, parentId = param.parentId, role = param.role, rolePos = param.rolePos;
    var groupId = useMemo(function() {
        return nanoid();
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, customComponents === null || customComponents === void 0 ? void 0 : customComponents.map(function(comp, i) {
        return /*#__PURE__*/ React.createElement("td", {
            key: "".concat(groupId, "__").concat(i)
        }, comp.component({
            parentId: parentId,
            role: role,
            groupId: groupId,
            rolePos: rolePos
        }));
    }));
};
